import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';
import {useReportRunForm} from '../hooks/use-report-run-form';
import {ReportRunDialogProps} from '../types/report-run.types';
import {ReportColumnFilter} from './report-column-filter';

export const ReportRunDialog = ({report, busy, download, onClose, onRun}: ReportRunDialogProps) => {
  const form = useReportRunForm(report);
  const submit = () => {
    if (busy) return;
    const overrides = form.prepare();
    if (overrides) void onRun(overrides);
  };

  return (
    <Dialog open onClose={busy ? undefined : onClose} maxWidth="sm" fullWidth aria-labelledby="run-report-title">
      <DialogTitle id="run-report-title">Параметры отчёта «{report.name}»</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{mb: 2}}>
          Укажите значения для этого запуска. Настройки шаблона сохранятся без изменений.
        </DialogContentText>
        {form.loading ? (
          <Box role="status" sx={{display: 'flex', gap: 2, alignItems: 'center', py: 2}}>
            <CircularProgress size={24} /> Загрузка полей отчёта…
          </Box>
        ) : form.error ? (
          <Alert
            severity="error"
            action={
              <Button color="inherit" onClick={form.retry}>
                Повторить
              </Button>
            }
          >
            {form.error}
          </Alert>
        ) : (
          <Box sx={{display: 'grid', gap: 3}}>
            {form.columns.map((column) => {
              const field = form.fields.find(({key}) => key === column.key)!;
              return (
                <Box key={column.key}>
                  <Typography component="h3" variant="subtitle2" sx={{mb: 1}}>
                    {field.label}
                  </Typography>
                  <ReportColumnFilter
                    field={field}
                    column={column}
                    error={form.errors[column.key]}
                    disabled={busy}
                    onChange={form.change}
                  />
                </Box>
              );
            })}
          </Box>
        )}
        {download.error && (
          <Alert severity="error" sx={{mt: 2}}>
            {download.error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Отмена
        </Button>
        <Button
          variant="contained"
          onClick={submit}
          disabled={busy || form.loading || Boolean(form.error) || !form.columns.length}
        >
          {busy ? (download.phase === 'downloading' ? 'Скачивается…' : 'Формируется…') : 'Сформировать и скачать'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
